export default __webpack_public_path__ + "static/product-img2-3a0a452bd08d0f9ea8c0572367f1f030.png";